'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconTextBold = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M17.194 10.962A6.271 6.271 0 0 0 12.844.248H4.3a1.25 1.25 0 0 0 0 2.5h1.013a.25.25 0 0 1 .25.25V21a.25.25 0 0 1-.25.25H4.3a1.25 1.25 0 1 0 0 2.5h9.963a6.742 6.742 0 0 0 2.93-12.786zm-4.35-8.214a3.762 3.762 0 0 1 0 7.523H8.313a.25.25 0 0 1-.25-.25V3a.25.25 0 0 1 .25-.25zm1.42 18.5H8.313a.25.25 0 0 1-.25-.25v-7.977a.25.25 0 0 1 .25-.25H14.264a4.239 4.239 0 0 1 0 8.477z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M3.5 24a.5.5 0 0 1 0-1H6V1H3.5a.5.5 0 0 1 0-1h2.97l.03-.002.031.002H13c3.308 0 6 2.692 6 6a5.993 5.993 0 0 1-2.976 5.182A6.502 6.502 0 0 1 21 17.5c0 3.584-2.916 6.5-6.5 6.5h-11zm11-1c3.033 0 5.5-2.467 5.5-5.5S17.533 12 14.5 12H7v11h7.5zM13 11c2.757 0 5-2.243 5-5s-2.243-5-5-5H7v10h6z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M3.75 23.998a.75.75 0 0 1 0-1.5H6v-21H3.75a.75.75 0 0 1 0-1.5h10.5a5.256 5.256 0 0 1 5.25 5.25 5.282 5.282 0 0 1-2.633 4.549A7.54 7.54 0 0 1 21 16.498c0 4.135-3.365 7.5-7.5 7.5H3.75zm9.75-1.5c3.308 0 6-2.692 6-6s-2.692-6-6-6h-6v12h6zm.75-13.5c2.068 0 3.75-1.682 3.75-3.75s-1.682-3.75-3.75-3.75H7.5v7.5h6.75z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconTextBold.displayName = 'IconTextBold';
exports.default = IconTextBold;